export default __webpack_public_path__ + "images/60be19e3337661c3dc5d6b7cb5e8acae-dinner.jpg";